import type Store from "@ember-data/store";
import { action } from "@ember/object";
import { service } from "@ember/service";
import type { ForcBaseArgs } from "parog-web/components/forc/abstract/base-component";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import journalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import type {
  Question,
  Section
} from "parog-web/models/ctcae-filled-journal-event";
import type CtcaeFilledJournalEvent from "parog-web/models/ctcae-filled-journal-event";
import type TaskPlannedJournalEvent from "parog-web/models/task-planned-journal-event";

export default abstract class CtcaeBaseForm extends CrudJournalEventBaseComponent<CtcaeFilledJournalEvent> {
  retrieveJournalEvent = journalEventRetrievalStrategies.sourceJournalEvent;

  declare sections: Section[];

  @service declare store: Store;

  constructor(owner: unknown, args: ForcBaseArgs) {
    super(owner, args);
    if (this.isNewMode) {
      this.sections = this.journalEventClass.currentSections(
        this.args.patient,
        this.store,
        this.args.originJournalEventId,
        this.args.originJournalEventType
      );
    } else {
      this.sections = (
        this.retrievedJournalEvent as CtcaeFilledJournalEvent
      )?.sectionsWithAnswers;
    }
  }

  @action
  async save(): Promise<typeof CtcaeFilledJournalEvent> {
    let task: TaskPlannedJournalEvent | null = null;
    this.changeset.set(
      "sections",
      this.sections.reduce((acc: Record<string, Question>, curr: Section) => {
        acc[curr.id] = curr.questions.reduce(
          (acc: Question, curr: Question) => {
            acc[curr.type] = curr.answer;
            return acc;
          },
          {} as Question
        );
        return acc;
      }, {})
    );

    if (
      Boolean(this.args.originJournalEventType) &&
      this.args.originJournalEventType == "TaskPlannedJournalEvent" &&
      Boolean(this.args.originJournalEventId)
    ) {
      task = this.store.peekRecord(
        "task-planned-journal-event",
        Number(this.args.originJournalEventId)
      );
      if (task) {
        this.changeset.set("originTaskIdentifier", task.originTaskIdentifier);
      }
    }

    const saved = await super.save();

    if (task) {
      await task.processTask("treated");
    }

    return saved;
  }
}
